const VAPID_PUBLIC_KEY = "BPq7Pik6gkWu3J0pbbeFqgEG36syf2NdSwhtnZqf0ktZLNYtywEWT1_foCveBzz6Hj4LXLoET10GB3ntXeWQnWY";
import { subscribe, unsubscribe } from "@/api/api.comunicazioni.js"

function urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

    const rawData = atob(base64);
    return Uint8Array.from([...rawData].map(char => char.charCodeAt(0)));
}

export async function requestNotificationPermission() {
    const permission = await Notification.requestPermission();
    return permission === "granted";
}

export async function getServiceWorkerRegistration() {
    if (!('serviceWorker' in navigator)) return null;
    return await navigator.serviceWorker.ready;
}

/* -------------------------
   SUBSCRIBE
-------------------------- */
export async function subscribeUser() {
    const permissionGranted = await requestNotificationPermission();
    if (!permissionGranted) {
        alert("Permesso per le notifiche negato.");
        return null;
    }

    const registration = await getServiceWorkerRegistration();
    if (!registration) {
        console.error("Service Worker non registrato.");
        return null;
    }

    const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
    });

    // Salva in localStorage
    localStorage.setItem("pushSubscription", JSON.stringify(subscription));

    // Invia al backend C#
    await subscribe(subscription);

    console.log("Utente iscritto alle notifiche:", subscription);
    return subscription;
}

/* -------------------------
   UNSUBSCRIBE
-------------------------- */
export async function unsubscribeUser() {
    const registration = await getServiceWorkerRegistration();
    const subscription = await registration.pushManager.getSubscription();

    if (!subscription) {
        console.log("Nessuna subscription attiva.");
        return false;
    }

    await subscription.unsubscribe();

    // Rimuovi dal backend
    await unsubscribe(subscription);

    localStorage.removeItem("pushSubscription");

    console.log("Utente disiscritto.");
    return true;
}

/* -------------------------
   CHECK STATE
-------------------------- */
export async function isUserSubscribed() {
    const registration = await getServiceWorkerRegistration();
    const subscription = await registration.pushManager.getSubscription();
    return subscription !== null;
}
